import type { SfmResourceProps } from 'src/AppScopes'
import { SfmResource } from 'src/AppScopes'

import { Create } from './Create'

export function ReportVersionResource(props: SfmResourceProps) {
  return <SfmResource {...props} create={Create} />
}
